export function getNextSubscriptionPeriod(subscription) {
    const currentPeriodEnd = subscription.current_period_end;
    const nextPeriod = subscription.schedule.phases.find(phase => (
        phase.start_date >= currentPeriodEnd
    ));
    return nextPeriod;
}